import React from "react";

// import "react-phone-input-2/lib/material.css";
import { useDispatch, useSelector } from "react-redux";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";


import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import BZLogo from "../../../components/BZLogo";
import { TwFormHelperText, TwInitialsAvatar, TwInputGroup, TwMainLayout, TwPhoneInputGroup, TwTextarea, TwWizard } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { clearDashboardData } from "../../../redux/reducers/dashboardReducer";
import { loadingState, setActionLoading } from "../../../redux/reducers/loadingReducer";
import { clearSchoolData } from "../../../redux/reducers/schoolReducer";
import { getUrlForBookings, getUrlForUsers } from "../../../utils/confighelpers";

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { BriefcaseIcon, UserGroupIcon, UserIcon } from "@heroicons/react/24/outline";
import { MinusCircleIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import OTPInput from "react-otp-input";
import profile_img from "../../../assets/avatar_placeholder.png";
import email_img from "../../../assets/Email.svg";
import facebook_img from "../../../assets/Facebook F.png";
import individual_profile from "../../../assets/individual_profile.svg";
import instagram_img from "../../../assets/Instagram.png";
import institute_img from "../../../assets/Institute.svg";
import linkedIn_img from "../../../assets/LinkedIn 2.png";
import progressdone from "../../../assets/progressdone.svg";
import twitter_img from "../../../assets/Twitter.png";
import web_img from "../../../assets/Website.svg";
import youtube_img from "../../../assets/YouTube.png";
import { classNames, isValidEmail } from "../../../helpers";
import * as userActions from "../../../redux/reducers/userReducer";
import BusinessProfileImgInput from "../../settings/businessProfile/BusinessProfileImgInput";
import I18nLanguageDropdown from "../../../components/I18nLanguageDropdown";

export default function OnBording({ }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const stateValue = userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : (location.state !== null ? location.state : null)
  const [onBoardingState, setOnBoardingState] = React.useState(
    {
      ...stateValue,
      myBusinessProfile: {
        // businessName: stateValue.fullName,
        businessName: "",
        businessTypes: "event",
        // businessProfileType: "business",
        businessProfileType: "",
        // logo: stateValue?.profilePic ? stateValue?.profilePic : "",
        logo: "",
        // images: [coverPhoto],
        about: "",
        locationObj: {},
        typeOfBusiness: "",
        workNumber: stateValue?.formattedPhoneNumber || "",
        workEmail: stateValue?.email || "",
        workWebsite: "",
        selectedView: "event",
        socialLink: [],
        address: {},
      },
      businessType: "event",
      // logo: stateValue?.profilePic && stateValue?.profilePic != defaultServerImage ? stateValue?.profilePic : "",
      logo: "",
    });
  const [myBusinessProfile, setMyBusinessProfile] = React.useState(
    {
      // businessName: stateValue.fullName,
      businessName: "",
      businessTypes: "event",
      // businessProfileType: "business",
      businessProfileType: "",
      // logo: stateValue?.profilePic && stateValue?.profilePic != defaultServerImage ? stateValue?.profilePic : "",
      logo: "",
      // images: [coverPhoto],
      about: "",
      locationObj: {},
      typeOfBusiness: "",
      workNumber: stateValue?.countryCode + " " + stateValue?.phoneNumber || "",
      workEmail: stateValue?.email || "",
      workWebsite: "",
      selectedView: "event",
      socialLink: [],
      address: {},
    });
  // dispatch(setActionLoading(false));

  const [defaultSocialLinks, setDefaultSocialLinks] = React.useState(
    [
      {
        name: "facebook",
        icon: facebook_img,
        placeholder: "facebook.com/mypage"
      },
      {
        name: "instagram",
        icon: instagram_img,
        placeholder: "instagram.com/mypage"
      },
      {
        name: "linkedIn",
        icon: linkedIn_img,
        placeholder: "linkedin.com/in/myprofile"
      },
      {
        name: "twitter",
        icon: twitter_img,
        placeholder: "twitter.com/mypage"
      },
      {
        name: "youtube",
        icon: youtube_img,
        placeholder: "youtube.com/mychannel"
      }]);

  const [socialLinksSelected, setSocialLinksSelected] = React.useState([]);
  const [formErrors, setFormErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const [resendEmailSubmitting, setResendEmailSubmitting] = React.useState(false);
  const [emailToken, setEmailToken] = React.useState("");

  const [otp, setOtp] = React.useState("");
  const cards = [
    {
      type: "class",
      title: "Bookzy Classes",
      data: "Choose this, if you host classes, workshops or other expierences",
      bgColor: "bg-secondary",
    },
    {
      type: "event",
      title: "Bookzy Events",
      data: "Choose this, if you host events, workshops, classes or other expierences",
      bgColor: "bg-light-primary",
    },
  ];
  const businessProfileTypeList = [
    {
      type: "individual",
      icons: UserIcon,
      title: "onBording.hostIndividual",
      data: "onBording.hostSubIndividual",
    },
    {
      type: "business",
      icons: BriefcaseIcon,
      title: "onBording.hostBusiness",
      data: "onBording.hostSubBusiness",
    },
    {
      type: "nonProfit",
      icons: UserGroupIcon,
      title: "onBording.hostNonProfit",
      data: "onBording.hostSubNonProfit",
    },
  ];

  const handleOnBoardingChange = (event) => {
    const { name, value } = event.target;

    setOnBoardingState((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const setOnBoardingStateValue = (name, value) => {
    setOnBoardingState((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleMyBusinessProfileChange = (event) => {
    const { name, value } = event.target;
    setMyBusinessProfile((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const setOnBoardingBusinessProfileValue = (name, value) => {
    setMyBusinessProfile((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  };

  React.useEffect(() => {
    setOnBoardingStateValue("myBusinessProfile", myBusinessProfile)
  }, [myBusinessProfile]);

  const handleResendEmail = async () => {

    const body2 = onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal" ? {
      countryCode: onBoardingState.countryCode,
      phoneNumber: onBoardingState.phone,
      // phoneNumber: values.contactNumber,
    } : {
      email: onBoardingState.myBusinessProfile.workEmail,
    };
    const config2 = {
      method: "put",
      url: `${getUrlForUsers()}updateProfile`,
      headers: {
        "x-access-token": userToken.toString(),
      },
      data: body2,
    };
    setResendEmailSubmitting(true);
    dispatch(setActionLoading(true));
    const requestEmail = await axios(config2);
    dispatch(setActionLoading(false));
    setTimeout(() => {
      setResendEmailSubmitting(false)
    }, 15 * 1000);
    if (requestEmail.status === 200) {
      if (requestEmail.data.statusCode === 403) {
        addErrorToast(requestEmail.data.message);
        return false;
      } else if (requestEmail.data.statusCode !== 200) {
        addErrorToast(requestEmail.data.message);
        return false;
      }
      setEmailToken(requestEmail.data.data.token);
    } else {
      addErrorToast(t("errors.somethingIsWrong"));
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    dispatch(setActionLoading(true));
    const body1 = {
      code: otp,
      token: emailToken,
    };
    const config1 = {
      method: "put",
      url: `${getUrlForUsers()}verifyPrimaryFieldsOtpAndUpdate`,
      headers: {
        "x-access-token": userToken.toString(),
      },
      data: body1,
    };
    const requestEmailVerification = await axios(config1);
    dispatch(setActionLoading(false));
    setSubmitting(false);
    if (requestEmailVerification.data?.statusCode === 500) {
      addErrorToast(requestEmailVerification.data?.message);
      return false;
    } else if (requestEmailVerification.data.statusCode === 201) {
      addErrorToast(requestEmailVerification.data?.message);
      return;
    }

    dispatch(setActionLoading(true));
    // }
    const body2 = {
      // ...onBoardingState,
      // businessType: onBoardingState?.businessType,
      businessType: "event",
      myBusinessProfile: onBoardingState?.myBusinessProfile,
      onBoardingStep: userReduxState.businessType === "service" ? 2 : 2
    };
    dispatch(setActionLoading(true));
    const requestAccountStepUp = await axios.put(
      `${getUrlForUsers()}updateProfile`,
      body2,
      { headers: { "x-access-token": userToken } }
    );
    dispatch(setActionLoading(false));
    if (requestAccountStepUp.status === 200) {
      if (requestAccountStepUp.data.statusCode === 200) {
        dispatch(userActions.setOnBoardingData(requestAccountStepUp.data.data));
        dispatch(userActions.setUserData(requestAccountStepUp.data.data));
        dispatch(userActions.setBusinessType(requestAccountStepUp.data.data.businessType));

        //** add createStripeCustomerAC **/
        dispatch(setActionLoading(true));
        const requestCreateStripeCustomerAC = await axios.post(
          `${getUrlForBookings()}payments/createStripeCustomerAC`,
          {},
          { headers: { "x-access-token": userToken } }
        );
        dispatch(setActionLoading(false));
        let nextUrl = "/my-subscription"

        navigate(nextUrl, {
          state: {
            from: "onbording",
          },
        })
      }
    }
    dispatch(setActionLoading(false));

  };
  React.useEffect(() => {

  }, []);


  return (
    <TwMainLayout fullScreen={true}>
      <OnBordingBaseLayout
        title={<BZLogo className={"!max-h-12 h-auto sm:!w-auto"} />}
        logoutCallBack={() => { }}
      >
        <div className="min-h-screen flex items-start justify-center 1bg-gray-100 w-full">
          <TwWizard
            className=""
            showSteps={false}
            steps={[
              {
                id: 1,
                name: t("onBording.s1Title"),
                nextBtnText: t("inputFieldsTitle.continue"),
                onNextClick: () => {
                  const errors = {};
                  if (!onBoardingState?.myBusinessProfile.businessProfileType || onBoardingState?.myBusinessProfile.businessProfileType === "") {
                    errors.businessProfileType = t("onBording.hostErrorMsg");
                  }
                  setFormErrors({ ...errors });
                  if (Object.keys(errors).length > 0) {
                    addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
                    return;
                  }


                  if (onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState?.myBusinessProfile?.businessProfileType === 'individual') {
                    setOnBoardingBusinessProfileValue("logo", stateValue?.profilePic ? stateValue?.profilePic : "")
                    setOnBoardingBusinessProfileValue("businessName", stateValue.fullName)
                  } else {
                    setOnBoardingBusinessProfileValue("logo", "")
                    setOnBoardingBusinessProfileValue("businessName", "")
                  }
                  return true
                },
                content: (<div className={"flex flex-col justify-center items-center gap-6"}>

                  <div className="w-full flex flex-col justify-start">
                    <h2 className="text-xl font-semibold">{t("onBording.s1Title")}</h2>
                    <p className="mt-1 text-sm/6 text-gray-400">{t("onBording.s1SubTitle")}</p>
                  </div>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                    {businessProfileTypeList?.map((items, i) => (<div
                      key={items.type}
                      className={classNames("cursor-pointer relative flex items-center space-x-3 rounded-lg border border-gray-300  px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-bz focus-within:ring-offset-2 hover:border-secondary 1hover:bg-list-hover text-black",
                        onBoardingState?.myBusinessProfile.businessProfileType && onBoardingState?.myBusinessProfile.businessProfileType === items.type ? "border-secondary bg-secondary text-white" : "bg-white"
                      )}

                      onClick={async () => {
                        setOnBoardingBusinessProfileValue("businessProfileType", items.type)
                      }}
                    >
                      <div className="min-w-0 flex-1 flex flex-col gap-4 items-center text-center">
                        <span aria-hidden="true" className="absolute inset-0" />
                        {items.icons && (<items.icons
                          aria-hidden="true"
                          className={classNames(
                            onBoardingState?.myBusinessProfile.businessProfileType && onBoardingState?.myBusinessProfile.businessProfileType === items.type ? 'text-white' : 'text-secondary group-hover:text-secondary',
                            'size-12 shrink-0',
                          )}
                        />)}
                        <p className={classNames("text-2xl font-medium",
                          onBoardingState?.myBusinessProfile.businessProfileType && onBoardingState?.myBusinessProfile.businessProfileType === items.type ? "" : "text-gray-900")}>{t(items.title)}</p>
                        <p className={classNames("[truncate] text-base",
                          onBoardingState?.myBusinessProfile.businessProfileType && onBoardingState?.myBusinessProfile.businessProfileType === items.type ? "" : "text-gray-500")}>{t(items.data)}</p>
                        {/* <TwButton
                          variant={"secondary-outline"}
                          className={classNames(`sm:w-full`, onBoardingState?.myBusinessProfile.businessProfileType && onBoardingState?.myBusinessProfile.businessProfileType === items.type ? "!ring-white !bg-secondary !text-white" : "")}
                        >
                          {t("inputFieldsTitle.select")}
                        </TwButton> */}
                      </div>
                    </div>))}
                  </div>
                  {formErrors["businessProfileType"] && (
                    <TwFormHelperText error={formErrors?.businessProfileType !== ""} className="w-full">{formErrors["businessProfileType"]}</TwFormHelperText>
                  )}
                </div>)
              },
              {
                id: 2,
                name: t(onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState?.myBusinessProfile?.businessProfileType === 'individual' ? "linkDescription.hostDetails" : "linkDescription.orgDetails"),
                showBack: true,
                showSkip: false,
                skipBtnText: t("inputFieldsTitle.btnIndividual"),
                onSkipClick: async () => {

                  setOnBoardingBusinessProfileValue("logo", stateValue?.profilePic ? stateValue?.profilePic : "")
                  setOnBoardingBusinessProfileValue("businessName", stateValue.fullName)
                  const errors = {};
                  if (!stateValue?.profilePic || stateValue?.profilePic === "") {
                    errors.logo = t("errors.isRequired");
                  }
                  // else if (!onBoardingState?.myBusinessProfile?.logo || onBoardingState?.myBusinessProfile?.logo === "") {
                  //   errors.logo = "Logo is Required!";
                  // }
                  if (!stateValue.fullName || stateValue.fullName === "") {
                    errors.businessName = t("errors.required");
                  }
                  // else if (!onBoardingState?.myBusinessProfile?.businessName || onBoardingState?.myBusinessProfile?.businessName === "") {
                  //   errors.businessName = t("errors.required");
                  // }
                  // if (!onBoardingState?.myBusinessProfile?.about || onBoardingState?.myBusinessProfile.about.length < 5) {
                  //   errors.about = t("errors.aboutusMinLength", { businessName: onBoardingState?.myBusinessProfile.businessName });
                  // }
                  setFormErrors({ ...errors });
                  if (Object.keys(errors).length > 0) {
                    addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
                    return;
                  }
                  return true
                },
                nextBtnText: t("inputFieldsTitle.continue"),
                onNextClick: () => {
                  const errors = {};
                  if (!onBoardingState?.myBusinessProfile?.logo || onBoardingState?.myBusinessProfile?.logo === "") {
                    errors.logo = t("errors.isRequired", { field: "Logo" });
                  }
                  if (!onBoardingState?.myBusinessProfile?.businessName || onBoardingState?.myBusinessProfile?.businessName === "") {
                    errors.businessName = t("errors.required");
                  }
                  // if (!onBoardingState?.myBusinessProfile?.about || onBoardingState?.myBusinessProfile.about.length < 5) {
                  //   errors.about = t("errors.aboutusMinLength", { businessName: onBoardingState?.myBusinessProfile.businessName });
                  // }
                  setFormErrors({ ...errors });
                  if (Object.keys(errors).length > 0) {
                    addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
                    return;
                  }
                  return true
                },
                content: (<div className={"flex flex-col justify-center items-center"}>
                  <div className={"flex flex-col justify-center items-center gap-5 w-full sm:w-full sm:max-w-sm md:max-w-lg"}>
                    <div className="w-full flex flex-col justify-start">
                      <h2 className="text-xl font-semibold">{t(onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState?.myBusinessProfile?.businessProfileType === 'individual' ? "onBording.s2HostTitle" : "onBording.s2OrgTitle")}</h2>
                      <p className="mt-1 text-sm/6 text-gray-400">{t(onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState?.myBusinessProfile?.businessProfileType === 'individual' ? "onBording.s2SubHostTitle" : "onBording.s2SubOrgTitle")}</p>
                    </div>
                    <div className="w-full flex justify-start">
                      <BusinessProfileImgInput
                        isOnBoarding={true}
                        setFieldValue={setOnBoardingBusinessProfileValue}
                        values={myBusinessProfile}
                        errors={formErrors}
                      />
                    </div>
                    <TwInputGroup
                      label={t(onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState?.myBusinessProfile?.businessProfileType === 'individual' ? "inputFieldsTitle.hostName" : "inputFieldsTitle.orgName")}
                      placeholder={t(onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState?.myBusinessProfile?.businessProfileType === 'individual' ? "inputFieldsTitle.hostNamePlaceholder" : "inputFieldsTitle.orgNamePlaceholder")}
                      name={"businessName"}
                      leftIcon={(<img className={""} src={onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState.myBusinessProfile.businessProfileType === 'individual' ? individual_profile : institute_img} alt={""} />)}
                      defaultValue={onBoardingState.myBusinessProfile?.businessName}
                      onChange={handleMyBusinessProfileChange}
                      errors={formErrors}
                    />
                    <TwTextarea
                      label={t(onBoardingState?.myBusinessProfile?.businessProfileType && onBoardingState?.myBusinessProfile?.businessProfileType === 'individual' ? "inputFieldsTitle.hostAbout" : "inputFieldsTitle.orgAbout")}
                      name={"about"}
                      row={3}
                      defaultValue={onBoardingState.myBusinessProfile?.about}
                      onChange={handleMyBusinessProfileChange}
                      errors={formErrors}
                    />
                  </div>
                </div>)
              },
              {
                id: 3,
                name: t("onBording.s3Title"),
                nextBtnText: t("inputFieldsTitle.continue"),
                onNextClick: async () => {
                  const errors = {};
                  // if (!onBoardingState?.myBusinessProfile?.address || !onBoardingState?.myBusinessProfile?.address?.addressName || onBoardingState?.myBusinessProfile?.address.addressName === "") {
                  //   errors.address = t("errors.required");
                  // }
                  if (onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal") {

                    if (!onBoardingState?.phone) {
                      errors.workNumber = t("errors.required");
                    } else if (onBoardingState?.phone.length > 0 && (onBoardingState?.phone.length < 8 || onBoardingState?.phone.length > 10)) {
                      errors.workNumber = t("errors.invalidPhoneNumber");
                    }
                  }
                  else if (!onBoardingState?.myBusinessProfile?.workEmail || onBoardingState?.myBusinessProfile?.workEmail === "") {
                    errors.workEmail = t("errors.required");
                  } else if (isValidEmail(onBoardingState?.myBusinessProfile?.workEmail) === false) {
                    errors.workEmail = t("errors.invalidEmail");
                  }
                  setFormErrors({ ...errors });
                  if (Object.keys(errors).length > 0) {
                    addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
                    return await false;
                  }

                  return await handleResendEmail();
                },
                content: (<div className={"flex flex-col justify-center items-center"}>
                  <div className={"flex flex-col justify-center items-center gap-5 w-full sm:w-full sm:max-w-sm md:max-w-lg"}>
                    <div className="w-full flex flex-col justify-start">
                      <h2 className="text-xl font-semibold">{t("onBording.s3Title")}</h2>
                      <p className="mt-1 text-sm/6 text-gray-400">{t("onBording.s3SubTitle")}</p>
                    </div>
                    {/* <TwLocationInput
                      label={"Organization Address"}
                      name={"address"}
                      leftIcon={(<img className={""} src={marker_img} alt={""} />)}
                      defaultLocationSelect={onBoardingState.myBusinessProfile?.address}
                      onLocationSelect={(data) => {
                        let addressObj = {
                          ...data,
                          addressName: onBoardingState.myBusinessProfile?.businessName,
                        }
                        setOnBoardingBusinessProfileValue("locationObj", addressObj)
                        setOnBoardingBusinessProfileValue("address", addressObj)
                        // setAddress(data);
                      }}
                      errors={formErrors}
                    /> */}
                    {onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal" ? (<TwPhoneInputGroup
                      label={t("inputFieldsTitle.number")}
                      placeholder={t("inputFieldsTitle.phoneNumber")}
                      name={"workNumber"}
                      country={"nl"}
                      defaultValue={onBoardingState.myBusinessProfile.workNumber}
                      onChange={(phone, country, e) => {
                        const numberWithoutDialCode = phone.split("");
                        for (let i = 0; i < country.dialCode.length; i++) {
                          numberWithoutDialCode.shift();
                        }
                        let dialCode = country.dialCode;
                        if (
                          country.format.includes("+") &&
                          !country.dialCode.includes("+")
                        ) {
                          dialCode = "+".concat(country.dialCode);
                        }
                        setOnBoardingBusinessProfileValue("workNumber", e.target.value);
                        setOnBoardingStateValue("formattedPhoneNumber", e.target.value);
                        setOnBoardingStateValue("countryCode", dialCode);
                        setOnBoardingStateValue("phone", numberWithoutDialCode.join(""));
                      }}
                      errors={formErrors}
                    />) :
                      (<TwInputGroup
                        label={t("inputFieldsTitle.email")}
                        placeholder={t("inputFieldsTitle.contactEmail")}
                        name={"workEmail"}
                        leftIcon={(<img className={""} src={email_img} alt={""} />)}
                        defaultValue={onBoardingState.myBusinessProfile?.workEmail}
                        onChange={handleMyBusinessProfileChange}
                        errors={formErrors}
                      />)}
                    <TwInputGroup
                      label={t("inputFieldsTitle.websiteOpt")}
                      placeholder={t("inputFieldsTitle.websiteOptPlaceholder")}
                      name={"workWebsite"}
                      leftIcon={(<img className={""} src={web_img} alt={""} />)}
                      defaultValue={onBoardingState.myBusinessProfile?.workWebsite}
                      onChange={handleMyBusinessProfileChange}
                      errors={formErrors}
                    />
                    <div className={"w-full sm:w-full sm:max-w-sm md:max-w-lg flex flex-col"}>
                      <div className={"mt-2"}>
                        <h4 className={"font-medium text-lg"}>
                          {t("inputFieldsTitle.linkToSocialMedia")} <span className={"text-base sm:text-sm md:text-sm text-center text-gray-400"}>{t("inputFieldsTitle.optional")}</span>
                        </h4>

                        <div className="flex items-center gap-3 mt-5">
                          {defaultSocialLinks.map((data) => (
                            <button
                              type="button"
                              key={data.name}
                              // onClick={() => setSelected(id)}
                              onClick={(event, newFormats) => {
                                let tempSocialLinksSelected = [...socialLinksSelected];
                                tempSocialLinksSelected = tempSocialLinksSelected.includes(data.name) ? tempSocialLinksSelected.filter(item => item !== data.name) : [...tempSocialLinksSelected, data.name]
                                setOnBoardingBusinessProfileValue("socialLinksSelected", tempSocialLinksSelected);
                                setSocialLinksSelected(tempSocialLinksSelected)
                              }}
                              className={`relative w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center border transition 
            ${(onBoardingState.myBusinessProfile?.socialLinksSelected && onBoardingState.myBusinessProfile.socialLinksSelected.indexOf(data.name) !== -1) ? "bg-gray-100 border-gray-300" : "bg-white border-gray-300"}`}
                            >
                              <img className={"w-4 md:w-6"} src={data.icon} alt={""} />
                              {/* {(onBoardingState.myBusinessProfile?.socialLinksSelected && onBoardingState.myBusinessProfile.socialLinksSelected.indexOf(data.name) !== -1) && (
                      <span className="absolute -top-2 -left-2 bg-green-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">
                        ✓
                      </span>
                    )} */}
                              {(onBoardingState.myBusinessProfile?.socialLinksSelected && onBoardingState.myBusinessProfile.socialLinksSelected.indexOf(data.name) !== -1) ? (<img className={"absolute w-5 md:w-8 indicator-item border-0 p-0 badge badge-lg -left-4 -top-2 md:-left-4 md:top-2 [-translate-y-3 translate-x-3 md:-translate-y-6 md:translate-x-6]"} src={progressdone} alt={""} />) : ""}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="flex flex-col gap-3 my-3">
                        {defaultSocialLinks.map((data, i) => {
                          return (
                            onBoardingState.myBusinessProfile?.socialLinksSelected && onBoardingState.myBusinessProfile.socialLinksSelected.indexOf(data.name) !== -1 && (

                              <div className="flex flex-row items-center gap-3" key={i}>
                                <TwInputGroup
                                  // label={"Name"}
                                  placeholder={data.placeholder}
                                  name={"socialLink.facebook"}
                                  defaultValue={onBoardingState.myBusinessProfile.socialLink[data.name]}
                                  leftIcon={(<img className={"size-4 md:size-6"} src={data.icon} alt={""} />)}
                                  onChange={(event) => {
                                    let socialLink = onBoardingState.myBusinessProfile.socialLink
                                    // setOnBoardingBusinessProfileValue("socialLink." + data.name, event.target.value);
                                    setOnBoardingBusinessProfileValue("socialLink", {
                                      ...socialLink,
                                      [data.name]: event.target.value,
                                    });
                                  }}
                                // errors={formErrors}
                                />
                                <button
                                  onClick={() => {
                                    let linksSelected = [...onBoardingState.myBusinessProfile.socialLinksSelected];
                                    linksSelected = linksSelected.filter(
                                      (link) => link !== data.name
                                    );
                                    setOnBoardingBusinessProfileValue("socialLinksSelected", linksSelected);
                                    let socialLink = onBoardingState.myBusinessProfile.socialLink
                                    setOnBoardingBusinessProfileValue("socialLink", {
                                      ...socialLink,
                                      [data.name]: "",
                                    });
                                    // setOnBoardingBusinessProfileValue("socialLink." + data.name, "");
                                  }}
                                >
                                  <MinusCircleIcon className="size-6 text-secondary" />
                                </button>
                              </div>
                            )
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>)
              },
              {
                id: 4,
                name: t("linkDescription.detailsVerification"),
                finishBtnText: t("inputFieldsTitle.verify"),
                onNextClick: async () => {
                  const errors = {};
                  if (otp === "") {
                    errors.otp = t("errors.required");
                  }
                  setFormErrors({ ...errors });
                  if (Object.keys(errors).length > 0) {
                    addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
                    return;
                  }
                  await handleSubmit()
                  return
                  // return true
                },
                content: (<div className={"flex flex-col justify-center items-center gap-4"}>
                  <div className="flex flex-col gap-2 justify-center text-center">
                    <h2 className="text-3xl md:text-3xl lg:text-4xl font-semibold">{onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal" ? t("inputFieldsTitle.verifyNumber") : t("inputFieldsTitle.verifyEmail")}</h2>
                    <p className="mt-1 text-sm/6 sm:text-sm text-gray-400">{t("forgotPassword.verifyForgotSubTitle1")}<br /><span className="text-primary">
                      {onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal" ? onBoardingState?.formattedPhoneNumber : onBoardingState?.myBusinessProfile?.workEmail}
                    </span></p>
                  </div>
                  {/* <div className={"text-center"}>
                    <p className={"sm:text-sm md:text-sm"}>
                      {t("forgotPassword.verifyForgotSubTitle1")}<br />
                      <span className="text-secondary">
                        {onBoardingState?.myBusinessProfile?.workEmail}
                      </span>
                    </p>
                  </div> */}
                  <OTPInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    containerStyle={`flex gap-4 justify-center`}
                    inputStyle={classNames(`!size-16 text-sm/6 text-gray-900 placeholder:text-gray-400 sm:text-base disabled:bg-gray-200 rounded-xl bg-input-bz outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2`,
                      formErrors.otp ? "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
                        : "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
                    )}
                    renderInput={(props) => <input {...props} />}
                    hasErrored={formErrors.otp}
                    shouldAutoFocus
                    inputType="number"
                  />
                  {formErrors.otpError && (
                    <TwFormHelperText
                      error={formErrors.otpError}
                    >
                      {t("errors.incorrectCode")}
                    </TwFormHelperText>
                  )}
                  <p
                    className={
                      "flex flex-row justify-center items-center text-base sm:text-sm md:text-sm"
                    }
                  >
                   {t("forgotPassword.verifyResendTitle")}&nbsp;
                    <button
                      type="button"
                      className={
                        "text-indigo-bz disabled:text-indigo-bz/30 font-bold transition-opacity active:opacity-50 text-base sm:text-sm md:text-sm"
                      }
                      onClick={handleResendEmail}
                      disabled={resendEmailSubmitting}
                    >
                      {onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal" ? t("inputFieldsTitle.resendSms") : t("inputFieldsTitle.resendCode")}
                    </button>
                  </p>
                  {/* <div className={"-mt-2"}>
                    <button
                      type="button"
                      className={
                        "text-center text-base sm:text-sm md:text-sm text-danger font-bold transition-opacity active:opacity-50"
                      }
                    // onClick={handleWrongNumber}
                    >
                      {onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal" ? "Wrong Number" : "Wrong Email"}
                    </button>
                  </div> */}
                </div>)
              },
            ]}
          />
        </div>
      </OnBordingBaseLayout>
    </TwMainLayout>)
}

export function OnBordingBaseLayout(props) {
  const { t, i18n } = useTranslation();
  const { children, className = "", title, logoutCallBack } = props
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const navigate = useNavigate();
  const userReduxState = useSelector(userState);
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const headerprofile = userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : (userReduxState.userData !== null ? userReduxState.userData : {})

  const userNavigation = [
    {
      id: "logout",
      label: t("authentication.logout"),
    }
  ]
  const userFullname = () => {
    let splitName = (headerprofile?.fullName || "")?.split(' ');
    let fullname = splitName.length ? splitName[0] : []
    if (splitName.length > 1) {
      fullname += " " + splitName[1].substring(0, 1) + "."
    }
    return fullname;
  };

  const logout = async () => {
    addToast("Logging out...");
    try {

      dispatch(setActionLoading(true));
      await axios.put(
        `${getUrlForUsers()}logoutUser`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userToken,
          },
        }
      );
      dispatch(setActionLoading(false));
    } catch (err) {
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("persist:root");
      dispatch(userActions.clearUserData());
      dispatch(clearSchoolData());
      dispatch(clearDashboardData());
      await setUserToken("");
      // navigate("/", { replace: true });
      window.location.href = "/";
    }
  };

  return (<div className="flex flex-col min-h-screen overflow-y-auto">
    <div className="sticky top-0 z-40 flex flex-row justify-between items-center shrink-0ß gap-x-4 border-b border-gray-200 bg-white shadow-md sm:gap-x-6 px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
      {typeof title == "string" ? (<h4
        className={
          "text-primary m-4 md:m-6  lg:my-6 lg:mx-16 font-bold text-2xl md:text-3xl flex-1"
        }
      >
        {title}
      </h4>) : (
        <div className="flex-1 [h-16]">
          {title}
        </div>)}
      {/* <TwButton
        className="shrink-0"
        onClick={async () => {
          await logout()
          if (logoutCallBack) {
            await logoutCallBack()
          }
        }}
      >
        Start Over
      </TwButton> */}
      <I18nLanguageDropdown />
      <Menu as="div" className="relative">
        <MenuButton className="-m-1.5 flex items-center p-1.5 rounded-full bg-zinc-300">
          <span className="sr-only">Open user menu</span>
          {headerprofile?.profilePic ? (<img
            className={"xs:size-6 size-7 md:size-8 lg:size-9 rounded-full bg-gray-50"}
            alt="" src={headerprofile?.profilePic ?? profile_img} />) : (
            <TwInitialsAvatar name={userFullname()} />
          )}
          <span className="hidden lg:flex lg:items-center">
            <span aria-hidden="true" className="ml-4 text-sm/6 font-semibold text-gray-900">
              {userFullname()}
            </span>
            <ChevronDownIcon aria-hidden="true" className="ml-2 size-5 text-gray-400" />
          </span>
        </MenuButton>
        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2.5 [min-w-36] min-w-0 flex-auto origin-top-right rounded-md bg-white py-2 ring-1 shadow-lg ring-gray-900/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
        >
          {userNavigation.map((item) => (
            <MenuItem key={item.label}>
              <button
                onClick={async () => {
                  // handleCloseUserMenu();
                  if (item.id === "logout") {
                    return await logout();
                  } else {
                    navigate(item.navigate.to, {
                      state: item.navigate.state,
                    });
                  }
                }}
                className="truncate w-full px-3 py-1 text-start text-sm/6 text-gray-900 hover:bg-gray-50 hover:outline-hidden focus:bg-gray-50 focus:outline-hidden"
              >
                {item.label}
              </button>
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>
    </div>
    {children}
  </div>)
}